import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import AccessTime from '@mui/icons-material/AccessTime';

const PREFIX = 'OrderingDisabled';

const classes = {
    icon: `${PREFIX}icon`
};

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    padding: theme.spacing(1.5),
    border: `1px solid ${theme.palette.primary.main}`,
    margin: theme.spacing(1.5),
    flexShrink: 0,
    [`& .${classes.icon}`]: {
        color: theme.palette.primary.main,
        marginRight: theme.spacing(1)
    }
}));

export const OrderingDisabled: React.FC<React.PropsWithChildren> = () => {
    const { t } = useTranslation();

    return (
        <StyledBox>
            <AccessTime className={classes.icon} />
            <Typography>{t('DIALOG_ORDERING_DISABLED_MESSAGE')}</Typography>
        </StyledBox>
    );
};
